import { gql, useMutation } from '@apollo/client';
import { RoleAssignmentMode } from '~/types';

const UPDATE_TASK_RESOURCE_ROLE_ASSIGNMENTS = gql`
  mutation UpdateTaskResourceRoleAssignments(
    $input: UpdateTaskResourceRoleAssignmentsInput!
  ) {
    updateTaskResourceRoleAssignments(input: $input) {
      taskId
      userId
    }
  }
`;

const useUpdateTaskResourceRoleAssignments = () => {
  const [mutate, { loading }] = useMutation(
    UPDATE_TASK_RESOURCE_ROLE_ASSIGNMENTS
  );

  const updateTaskResourceRoleAssignments = ({
    taskUri,
    resourceUserUri,
    roleAssignmentMode,
    rolesToAssign,
    roleUrisToUnassign
  }) => {
    const isSpecificRoles =
      roleAssignmentMode === RoleAssignmentMode.SpecificRoles;

    return mutate({
      variables: {
        input: {
          taskUri,
          resourceUserUri,
          roleAssignmentMode,
          specificRolesToBeAssigned: isSpecificRoles
            ? rolesToAssign.map(({ roleUri, isDefault }) => ({
                roleUri,
                isDefault
              }))
            : null,
          specificRoleUrisToBeUnassigned: isSpecificRoles
            ? [...roleUrisToUnassign]
            : null
        }
      }
    });
  };

  return { updateTaskResourceRoleAssignments, loading };
};

export default useUpdateTaskResourceRoleAssignments;
